<template>
  <div class="preventiva-os_erp ml-4 mr-4" >
          <b-form>          
          <b-row>
            <LoadingModal v-if="isLoading" />

              <b-col>
                <label for="select-garagem">Garagem</label> 
                <multiselect id="cmbgaragem" 
                v-model="value_garagem"  required
                :options="garagens"  size="sm" 
                :multiple="false" :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" 
                :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>                                        
                </multiselect> 
              </b-col>
            
            <!--
              filtros dos serviços
            -->
              <b-col>
                <label for="select-servico">Serviço</label>
                <multiselect  v-model="value_servico" required :options="servicos" :multiple="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true"   placeholder="Selecione o serviço" label="servico" track-by="servico" :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Servico selecionado</span></template>                                        
                </multiselect> 
              </b-col>            
<!--
              <b-col>
                <label for="select-status">Status</label> 
                <multiselect  v-model="value_status" required :options="statuss" :multiple="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true"   placeholder="Selecione o status" label="status" track-by="status" :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>                                        
                </multiselect> 
              </b-col>
   -->         
              <b-col>
                   <div>                            
                        <label  for="datepicker-placeholder">Data inicio</label>
                        
                        <b-form-datepicker id="datepicker-placeholder" required  v-model="emissao_inicio" placeholder="Data inicio" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>

              <b-col>
                <div>                            
                    <label  for="datepicker-placeholder">Data Fim</label>
                    <b-form-datepicker id="datepicker-placeholder2" required v-model="emissao_fim" placeholder="Data fim" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>
           
              <b-col >
                <label  for="input-busca">Pesquisa no grid  </label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Carro / O.S / Serviço"></b-form-input>              
              </b-col>   
              

              <!-- botão para acionar a pesquisa -->
              <b-col>
                <br>                
                <b-button size="sm" variant="primary" class="mr-2 mt-2" block  @click="carregando = true,loadPreventivaMonitoramentos()">
                  Pesquisar
                </b-button>                      
              </b-col>

              
              <!-- botão para acionar a pesquisa -->
              <b-col>
                <br>                
                <b-button size="sm" variant="success" class="mr-2 mt-2" block @click="carregando = true,gerarPlanilha()">
                  Gerar planilha
                </b-button>                      
              </b-col>


          </b-row>
          
          


    </b-form>






    <!--                  -->
    
      

      <!--  <b-card-group class="ml-3 mt-3 mb-3" deck>    -->
        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QTD ORDEM DE SERVIÇO(s)"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    

                    {{ 
                      new Set(itemsFiltered.map(v => v.os_erp)).size
                    }}
                  
                  </h2>
                </b-card-text>
              </b-card>   


              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QTD SERVIÇO(s)"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ itemsFiltered.length }}
                  </h2>
                </b-card-text>
              </b-card>
            

         <!-- 
      
          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="R$ CONSUMO DE PEÇAS"
            header-bg-variant="green"
            header-text-variant="white"
            align="center"
          >
            
          <b-card-text > 
              <h2>                        

              {{ itemsFiltered
                .map(v => parseFloat(v.total_os.replace(/[^\d.,]/g, '')))
                .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0)
                .toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }) 
              }}
                
              </h2>             
            </b-card-text>
          </b-card>

          -->

        </b-card-group> 
      

      




        <b-table small hover striped sticky-header="830px"  :items="itemsFiltered" :fields="fieldsServicos"> 
          <template slot="cell(actions)" slot-scope="data"  >
            
            <!--
            <b-button @mouseup="loadCarregaOs(data.item)" @click="modalShowTarefas = !modalShowTarefas,loadPreventivasOsTarefas()" title="Tarefas"  size="sm" variant="success" class="mr-2">                
              <i class="fa fa-tasks"></i>
            </b-button>            

            <b-button @click="loadCarregaOs(data.item)" title="Tarefas"  size="sm" variant="success" class="mr-2" v-b-modal.modal-multi-preventivaTarefas>                
              <i class="fa fa-tasks"></i>
            </b-button>      
            -->
            <b-button @click="loadCarregaOs(data.item)"  title="Tarefas" size="sm" variant="primary" class="mr-2" v-b-modal.modal-multi-preventivaFotos>              
              <i class="fa fa-list-ol"></i>
            </b-button>

            <b-button @click="loadCarregaOs(data.item)"  title="Peças utilizadas" size="sm" variant="danger" class="mr-2" v-b-modal.modal-multi-preventivaPecas>              
              <i class="fa fa-gear"></i>
            </b-button>



          </template>
        </b-table>    

        <!--Modal Tarefas -->
        <div>
            
            <b-modal id="modal-multi-preventivaTarefas" cancel-title="Fechar"   size="xl" title="Tarefas"   no-close-on-esc no-close-on-backdrop>  
                            
              <font color="blue"> {{'Carro.: '+preventivamonitoramento.carro + ' - Serviço.: ' + preventivamonitoramento.id_servico+'-'+preventivamonitoramento.servico +' - ' + preventivamonitoramento.reexecutante }}</font>  
              <div class="modal-body" modal-body>            
                <b-table  small hover striped sticky-header="780px" :items="loadPreventivasostarefas" :fields="fieldstarefas">
                </b-table> 
              <b-button size="sm"  variant="outline-success" @click="cancel()">
                Planilha
              </b-button>
              </div> 


              <template #modal-footer="{ cancel }">              
              <!-- Button with custom close trigger value -->
              <b-button size="sm"  variant="outline-primary" @click="cancel()">
                Voltar
              </b-button>

              

            </template>

                       
            </b-modal> 
        </div>

                <!--Modal Fotos -->
        <div>
            
<b-modal :id="'modal-multi-preventivaFotos'" cancel-title="Fechar" ok-title="Planilha" size="xl" title="Relação das tarefas dos serviços" no-close-on-esc no-close-on-backdrop>
  <font color="blue">{{'Carro.: '+preventivamonitoramento.carro + ' - Serviço.: ' + ' - '+preventivamonitoramento.servico}}</font>
  <div class="modal-body" modal-body>
    <b-table small hover striped sticky-header="810px"  :items="loadPreventivasostarefas" :fields="fieldstarefasfotosexecutantes">

      <template v-slot:cell(terafa)="data">
        <div style="width: 500px;"> <!-- Define a largura da célula -->    
        <!-- <p>{{ getFormattedDate(data.item.thumbnail_encarregado) }}</p> -->
        </div>
</template>


      <!-- Customização da célula com a foto -->
      <template v-slot:cell(thumbnail_encarregado)="data">
        <div>
          <img :src="data.item.thumbnail_encarregado" alt="-" class="thumbnail-image">
          <!-- <p>{{ getFormattedDate(data.item.thumbnail_encarregado) }}</p> -->
        </div>
      </template>



      <template v-slot:cell(thumbnail_executante)="data">
        <div>
          <img :src="data.item.thumbnail_executante" alt="-" class="thumbnail-image">          
        </div>
      </template>


    </b-table>
  </div>

  <template #modal-footer="{ cancel, ok }">
    <!-- Button with custom close trigger value -->
    <b-button size="sm" block variant="outline-primary" @click="cancel()">
      Voltar
    </b-button>


    <b-button size="sm" block variant="outline-primary" @click="gerarPlanilhaAtividades()">
      Gerar Planilha
    </b-button>





  </template>
</b-modal>


        </div>
        

        <!-- Modal pecas -->
        <div>
            <b-modal id="modal-multi-preventivaPecas" cancel-title="Fechar"   size="xl" title="Consumo de peças"   no-close-on-esc no-close-on-backdrop>                
            <font color="blue"> {{'Carro.: '+preventivamonitoramento.carro+ ' Serviço.: ' +preventivamonitoramento.servico }}</font>                                     
            <div >                 
              <b-table  v-model="tablepecas"  small hover striped sticky-header="530px"  :fields="fieldspecas"  :items="loadPreventivasospecas" >                 
              </b-table>
            </div>

            <template #modal-footer="{ cancel }">              
              <!-- Button with custom close trigger value -->
              
              <b-button size="sm" block variant="outline-primary" @click="cancel()">
                Voltar
              </b-button>

              <b-button size="sm" block variant="outline-primary" @click="gerarPlanilhaPecas()">
                Gerar Planilha
              </b-button>
            </template>
            
          </b-modal>
        </div>
      
        
    </div>
</template>

<script>
//import { baseApiUrl } from '@/global'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'
import { baseApiUrl, showError  } from '@/global'


export default {
    name: 'PreventivaAdmin',

    computed : { ... mapState (['user'],),




    
        itemsFiltered(){
        let valores = [];       
        valores = this.preventivamonitoramentos.filter((item) =>{ 
          const carro = item.carro || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const os_erp = item.os_erp || '';
          const servico = item.servico || '';
          
           return (
             carro.indexOf(this.search) >-1 ||
             os_erp.indexOf(this.search) >-1 ||
             servico.indexOf(this.search) >-1
                   
            
          );
        });
           return valores

        },

        



   
    } ,


    
    data: function() {
        return {
         
            
            isLoading: false,         
            mode: 'save',
            carregando: false,
            garagem:{},
            garagens: [],  
            value_garagem:[],// [] lista        

            servico:{},
            servicos: [],  
            value_servico:[],// [] lista  

            status:{},
            statuss: [],  
            value_status:[],// [] lista  
            emissao_inicio: '',      
            emissao_fim: '',   

            preventivamonitoramento: {}, 
            preventivamonitoramentos:[], // array de preventiva

            preventivasospeca: {},
            preventivasospecas: [],

            preventivasostarefa: {},
            preventivasostarefas: [],
            loadPreventivasostarefas: [],
            loadPreventivasospecas:[],
            search:'',
            

              

            fieldsServicos:[              
              { key: 'id_filial', label: 'Garagem', sortable: true },   
              { key: 'os_erp', label: 'Nro O.S', sortable: true },   
              { key: 'dt_emissao', label: 'Emissão', sortable: true, formatter: (value, key, preventivamonitoramentos) => {
                return moment(preventivamonitoramentos.dt_emissao).format('DD/MM/YYYY');} },
              { key: 'status', label: 'Status', sortable: true },   
              { key: 'dt_inicio_servico', label: 'Inicio', sortable: true, formatter: (value, key, preventivamonitoramentos) => {
                return moment(preventivamonitoramentos.dt_inicio_servico).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },                                                   
              { key: 'dt_fim_servico', label: 'Término', sortable: true, formatter: (value, key, preventivamonitoramentos) => {
                return moment(preventivamonitoramentos.dt_fim_servico).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },                                                   
              { key: 'carro', label: 'Carro', sortable: true },                  
              { key: 'servico', label: 'Serviço', sortable: true },                                   
              { key: 'limite', label: 'Limite', sortable: false },
              { key: 'executado', label: 'Executado', sortable: false },                                  
              { key: 'reencarregado', label: 'Encarregado', sortable: false },    
              { key: 'reexecutante', label: 'Executante', sortable: false },    
              { key: 'actions', label: 'Ações' }
            ],
               // { key: 'diferenca', label: 'Diferença', sortable: true }, 
           //     { key: 'dt_fim_servico', label: 'Término', sortable: true, formatter: (value, key, preventivamonitoramentos) => {
             //          return moment(preventivamonitoramentos.dt_fim_servico).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },

             

            /////////////////////////////////////////////////
            ////////////////////////////////////////////////
            fieldspecas: [                              

                { key: 'data_mov', label: 'Dt_movimento', sortable: true, formatter: (value, key, preventivasospecas) => {
                    return moment(preventivasospecas.data_mov).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },   

                { key: 'carro', label: 'carro', sortable: true },              
               // { key: 'modelo_chassi', label: 'modelo_chassi', sortable: true },
                { key: 'rotina', label: 'rotina', sortable: true },                
                { key: 'requisicao', label: 'requisicao', sortable: true },                
                { key: 'quantidade', label: ' quantidade', sortable: true },
                { key: 'material', label: 'material', sortable: true },
                //{ key: 'valor_unitario', label: 'valor_unitario', sortable: true },
                //{ key: 'valor_total', label: 'valor_total', sortable: true },
                { key: 'os', label: 'os', sortable: true },
                { key: 'requisitante', label: 'requisitante', sortable: true },
                
               
            ],
                        
            
            



            /////////////////////////////////////////////////
            ////////////////////////////////////////////////
            fieldstarefas: [               
                
               // { key: 'dt_emissao', label: 'dt_emissao', sortable: true, formatter: (value, key, preventivasostarefas) => {
               //     return moment(preventivasostarefas.dt_emissao).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },   

               { key: 'carro', label: 'carro', sortable: true },              
               // { key: 'servico', label: 'servico', sortable: true },
                { key: 'grupo', label: 'grupo', sortable: true },                
                { key: 'tarefa', label: ' tarefa', sortable: true },
                { key: 'encarregado', label: 'encarregado', sortable: true },
                

                { key: 'status_tarefa_encarregado', label: 'status_encarregado', sortable: true },
                
                { key: 'dt_delegado_app', label: 'Data delegado', sortable: true, formatter: (value, key, preventivasostarefas) => {
                    return moment(preventivasostarefas.dt_delegado_app).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },  

              { key: 'executante', label: 'executante', sortable: true },

                { key: 'dt_termino_app', label: 'Data término', sortable: true, formatter: (value, key, preventivasostarefas) => {
                    return moment(preventivasostarefas.dt_termino_app).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },  


                { key: 'status_tarefa_executante', label: 'status_executante', sortable: true },
                { key: 'observacao', label: 'observacao', sortable: true },
            ],





            /////////////////////////////////////////////////
            ////////////////////////////////////////////////
            fieldstarefasfotosexecutantes: [               

                { key: 'grupo', label: 'grupo', sortable: true },                
                { key: 'tarefa', label: ' tarefa', sortable: true },

                { key: 'thumbnail_encarregado', label: 'Foto encarregado', sortable: true },
                { key: 'encarregado', label: 'encarregado', sortable: true },
                { key: 'status_tarefa_encarregado', label: 'status_encarregado', sortable: true },
                { key: 'dt_delegado_app', label: 'Data delegado', sortable: true, formatter: (value, key, preventivasostarefas) => {
                    return moment(preventivasostarefas.dt_delegado_app).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },  

                { key: 'thumbnail_executante', label: 'Foto executante', sortable: true },
                { key: 'executante', label: 'executante', sortable: true },
                { key: 'status_tarefa_executante', label: 'status_executante', sortable: true },
                { key: 'dt_termino_app', label: 'Data término', sortable: true, formatter: (value, key, preventivasostarefas) => {
                    return moment(preventivasostarefas.dt_termino_app).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },  

                { key: 'observacao', label: 'observacao', sortable: true },
            ],




        }        
    },
    

        components: {
        Multiselect,LoadingModal
    },

    methods: {

        gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.itemsFiltered

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'preventivas_sintetico.xlsx');
      },

              gerarPlanilhaAtividades() {
        // Objeto com os dados para a planilha
        const dados = this.loadPreventivasostarefas

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'preventivas_tarefas.xlsx');
      },

              gerarPlanilhaPecas() {
        // Objeto com os dados para a planilha
        const dados = this.loadPreventivasospecas

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'preventiva_pecas.xlsx');
      },


        loadGaragens() {
          const url = `${baseApiUrl}/preventiva/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_garagem: garagem.id_garagem, garagem: garagem.garagem }
            })
          })
        },

        loadServicos() {
          const url = `${baseApiUrl}/preventiva/servico`
          axios.get(url).then(res => {
            this.servicos = res.data.map(servico => {              
              return { id_servico: servico.id_servico, servico: servico.servico }
            })
          })
        },

        loadStatuss() {
          const url = `${baseApiUrl}/preventiva/status`
          let corpo = {                    
                "web":'web'
            };
          axios.post(url,corpo).then(res => {
            this.statuss = res.data.map(status => {              
              return { id_status: status.id_status, status: status.denominacao }
            })
          })
        },

        async loadPreventivasOsPecas() {      
            let corpo = {                    
                "os_erp": `${[this.preventivamonitoramento.os_erp]}`
            };

             const url = await `${baseApiUrl}/preventiva/pecas`                               
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.loadPreventivasospecas = res.data                
            })            
        },

        async loadPreventivasOsTarefas() {                        
              let corpo = {                    
                "os_erp": `${[this.preventivamonitoramento.os_erp]}`,
                "id_servico": `${[this.preventivamonitoramento.id_servico]}`
            };            

            const url = await `${baseApiUrl}/preventiva/tarefas`                               
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.loadPreventivasostarefas = res.data       
          })  
        },


        loadPreventivaMonitoramentos() {
          this.isLoading = true; // Desative o indicador de carregamento             

            let corpo = {    
                "id_filial": this.value_garagem.id_garagem ? `${[this.value_garagem.id_garagem]}` : `${[this.garagens.map(at => at.id_garagem).join(', ')]}`,                
                //"id_filial": `${[this.value_garagem.id_garagem]}` ,                
                "id_servico": `${[this.value_servico.id_servico]}`,               
                "id_status": `${[this.value_status.id_status]}`,        
                "dt_inicio": `${[this.emissao_inicio]}`,                
                "dt_fim": `${[this.emissao_fim]}`,
                "origem": 'web'
            };


            const url = `${baseApiUrl}/preventiva/monitoramento`            
            axios.post(url,corpo).then(res => {              
                //this.carregando = false;
                this.preventivamonitoramentos = res.data.map(preventivamonitoramento => {
                            return {                              
                              id_filial: preventivamonitoramento.id_filial, 
                              dt_emissao: preventivamonitoramento.dt_emissao, 
                              os_erp: preventivamonitoramento.os_erp,
                              carro: preventivamonitoramento.carro, 
                              id_servico: preventivamonitoramento.id_servico,
                              servico: preventivamonitoramento.servico, 
                              escalonamento: preventivamonitoramento.escalonamento,
                              limite: preventivamonitoramento.limite,
                              executado: preventivamonitoramento.executado, 
                              diferenca: preventivamonitoramento.diferenca, 
                              dt_inicio_servico: preventivamonitoramento.dt_inicio_servico, 
                              dt_fim_servico: preventivamonitoramento.dt_fim_servico, 
                              status: preventivamonitoramento.status,
                              total_os: preventivamonitoramento.total_os,
                              fechado_via: preventivamonitoramento.fechado_via,
                              reexecutante: preventivamonitoramento.reexecutante,
                              reencarregado: preventivamonitoramento.reencarregado,
                            }              
                                                            })
                              this.isLoading = false; // Desative o indicador de carregamento             

                            })
                            .catch(showError)
        },

        loadCarregaOs(preventivamonitoramento){
            this.preventivamonitoramento = { ...preventivamonitoramento }
            this.loadPreventivasOsTarefas()
            this.loadPreventivasOsPecas()
        },          
    },

    mounted() {        
      this.loadGaragens()
        this.loadServicos()
        this.loadStatuss()        
      this.loadPreventivaMonitoramentos()
        //this.loadCarregaOs()
        //this.loadPreventivasOsPecas()
        //this.loadPreventivasOsTarefas()          
    },

}



</script>

<style>
  .table{
      font-size: 0.7em;
      
  }

  .multiselect__option {
    font-size: 10px;    
  }

  span.multiselect__single{
    font-size: 10px;    
  }

  .thumbnail-image {
  max-width: 98px;
  max-height: 98px;
}

  .custom-modal-content {
    width: 90%; /* Defina a largura que desejar, por exemplo, 90% */
    max-width: 1000px; /* Defina uma largura máxima, se desejar */
    margin: 0 auto; /* Para centralizar o modal na tela */
  }



</style>